const paths = {
    signUp: "/signup",
    dasboard: "/dashboard",
    profile: "/profile",
    photos: "/photos",
    videos: '/videos',
    documents: "/documents"
}

export { paths }